<template>
  <div @click="()=>goBack()" style="margin-top: 20px;margin-bottom: 30px;" class="flex flex-c-c pointer">
    <i class="iconfont icon-left" style="font-size: 20px"></i>
    <span class="">{{$t('lang.返回')}}</span>
  </div>
</template>
<script>
  import {goBack} from '../../common/utils/routerUtil';

  export default {
    methods: {
      goBack() {
        goBack()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/returnBackButton.vue